module.exports = __webpack_public_path__ + "static/media/ap-swiper-pc-3.9296cac2.png";